import { fetchBookingSettings } from "@/api/providerDashboard";

export default {
  async loadSettings() {
    try {
      const res = await fetchBookingSettings();
      if (res.data.status === 200 && res.data.data) {
        const d = res.data.data;
        this.onlineBookingEnabled = d.onlineBookingEnabled !== false;
        if (d.bookingSettings) {
          const bs = d.bookingSettings;
          if (bs.businessHours) {
            for (const day of this.dayOrder) {
              if (bs.businessHours[day]) {
                this.businessHours[day] = {
                  ...this.businessHours[day],
                  ...bs.businessHours[day],
                };
              }
            }
          }
          if (bs.bookingInterval) this.bookingInterval = bs.bookingInterval;
          if (bs.maxConcurrentBookings)
            this.maxConcurrent = bs.maxConcurrentBookings;
          if (bs.holidays) this.holidays = bs.holidays;
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.loading = false;
    }
  },
};
